import { useExperiment } from '@moonpig/web-core-eppo/browser'

const MORE_LIKE_THIS_EXPERIMENT_KEY = 'search-use-more-like-this-v3'

export const useCanNavigateInModal = () => {
  const moreLikeThisExperiment = useExperiment(MORE_LIKE_THIS_EXPERIMENT_KEY, {
    fallback: 'control',
  })

  return (
    moreLikeThisExperiment === 'carousels' || moreLikeThisExperiment === 'tabs'
  )
}
